import {
  ShipmentStatusCell,
  ShipmentAlertCell,
  ShipmentLabelCell,
  ShipmentDevicesCell,
  ShipmentProjectCell,
  ShipmentStartDateCell,
  ShipmentEndDateCell,
  ShipmentDownloadCell
} from './shipment';

export const shipmentTableHeadMap = {
  status: ShipmentStatusCell,
  alert: ShipmentAlertCell,
  label: ShipmentLabelCell,
  devices: ShipmentDevicesCell,
  project: ShipmentProjectCell,
  startDate: ShipmentStartDateCell,
  endDate: ShipmentEndDateCell,
  download: ShipmentDownloadCell
};
